var VideoCameraViewModal = (function (base) {
  __extends(VideoCameraViewModal, base);

  function VideoCameraViewModal(apiClient) {
    const self = base.call(this, apiClient) || this;
    return self;
  };

  VideoCameraViewModal.prototype.activate = function (vcameraId, deleteFunc, showOnMapFunc) {
    const self = this;
    const url = `api/videocameras/${vcameraId}`;

    this.loadContent(url)
      .then($modal => {

        $modal

          // Редактирование
          .on('click', '[js=edit]', function () {
            ModalConductor.activate(VideoCameraEditModal, vcameraId)
              .on('closed', (modalResult) => {
                if (modalResult.ok) {
                  self.reloadContent(url);
                }
              });
          })

          // Удаление
          .on('click', '[js=delete]', function () {
            if (confirm(`Вы действительно хотите удалить эту видеокамеру?`)) {
              deleteFunc(vcameraId);
            }
          })

          // Показать на карте
          .on('click', '[js=show-on-map]', function () {
            showOnMapFunc(vcameraId);
          });
      });
  };

  return VideoCameraViewModal;
}(BaseModal));
